import {
    DOCUMENT_MUTATOR_LOAD_SELECTED,
    DOCUMENT_MUTATOR_RESET_DEFAULTS,
    DOCUMENT_MUTATOR_SET_BUILDING_ID,
    DOCUMENT_MUTATOR_SET_CLIENT_ID,
    DOCUMENT_MUTATOR_SET_FILE,
    DOCUMENT_MUTATOR_SET_NAME,
    DOCUMENT_MUTATOR_SET_PROPERTY_ID,
} from './actionTypes.js'

const defaultState = {
    buildingId: null,
    clientId: null,
    id: null,
    name: null,
    propertyId: null,
}

const documentMutatorReducer = (state = defaultState, action) => {
    switch (action.type) {
        case DOCUMENT_MUTATOR_LOAD_SELECTED:
            return {
                ...state,
                buildingId: action.selectedDocument.buildingId,
                clientId: action.selectedDocument.clientId,
                id: action.selectedDocument.id,
                name: action.selectedDocument.name,
                propertyId: action.selectedDocument.propertyId,
            }

        case DOCUMENT_MUTATOR_RESET_DEFAULTS:
            return defaultState

        case DOCUMENT_MUTATOR_SET_BUILDING_ID:
            return {
                ...state,
                buildingId: action.buildingId,
            }

        case DOCUMENT_MUTATOR_SET_CLIENT_ID:
            return {
                ...state,
                clientId: action.clientId,
            }

        case DOCUMENT_MUTATOR_SET_FILE:
            return {
                ...state,
                document: action.file,
            }

        case DOCUMENT_MUTATOR_SET_NAME:
            return {
                ...state,
                name: action.name,
            }

        case DOCUMENT_MUTATOR_SET_PROPERTY_ID:
            return {
                ...state,
                propertyId: action.propertyId,
            }

        default:
            return state
    }
}

export default documentMutatorReducer
